<app-slider *ngIf="images && images.length > 0" (clickItem)="clickItem($event)">
  <app-gallery-item
    *ngFor="let image of images"
    [image]="image"
    (itemClick)="onSliderClick($event)">
  </app-gallery-item>
</app-slider>
